import React from 'react';
import { Flex, BoxV2 as Box, Table, useTable } from 'portal-commons';
import { fetchEventHistory } from '@/applications/CspPortal/Events/apiServices';
import { MAX_EVENT_RECORDS } from '@/applications/CspPortal/Events/constants';
import { Event } from '@/applications/CspPortal/Events/types';
import EventListingRow from '@/components/EventListingRow';
import { DEFAULT_ADDITIONAL_FILTERS } from '@/utils/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  brandUid: string;
}

const headRows = [
  { label: 'EVENT TYPE', id: 'eventType', sortable: true },
  { label: 'CATEGORY', id: 'categoryType', sortable: true },
  { label: 'CAMPAIGN ID', id: 'campaignUid', sortable: true },
  { label: 'BRAND ID', id: 'brandUid', sortable: true },
  { label: 'DATE & TIME', id: 'createDate', sortable: true },
  { label: 'USER', id: 'authenticatedUser', sortable: false },
  { label: 'DESCRIPTION', id: 'description', sortable: false },
];

const BrandEvents: React.FC<Props> = ({ brandUid }) => {
  const table = useTable<Event>(
    async (filter) => {
      const query = { ...filter, recordsPerPage: 10, brandUid };
      const eventData = await fetchEventHistory(query);

      return {
        data: eventData?.records || [],
        page: eventData?.page || 1,
        rowsPerPage: eventData?.recordsPerPage || 10,
        total: eventData?.totalRecords || 0,
      };
    },
    {
      cappingTotal: MAX_EVENT_RECORDS,
      deps: [],
      defaultFilter: DEFAULT_ADDITIONAL_FILTERS,
      inMemory: true,
    }
  );

  return (
    <Box
      sx={{
        my: 30,
        p: '25px 30px 20px',
        width: '100%',
        border: '1px solid #C0CCD4',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          width: '100%',
          alignItems: 'flex-start',
        }}
      >
        <Flex sx={{ alignItems: 'center', mb: 20 }}>
          <Box sx={{ mr: 'xs' }}>
            <FontAwesomeIcon icon={faCalendarRange} size="xl" />
          </Box>
          <Box
            as="h3"
            sx={{ fontSize: 16, fontWeight: '500', color: '#49535D' }}
          >
            Events
          </Box>
        </Flex>
        <Table
          headRows={headRows}
          emptyState="no events to view"
          disableHover
          loading={table.loading}
          tableData={table.tableData.map((record, idx) => {
            return (
              <EventListingRow
                key={`record_${idx}`}
                event={record}
                campaignLink
              />
            );
          })}
          handleChangePage={table.handleChangePage}
          createSortHandler={table.handleSorting}
          filter={table.filter}
          pagination={table.pagination}
          testId="brandEventsTable"
          emptyBlockHeight="180px"
        ></Table>
      </Flex>
    </Box>
  );
};

export default BrandEvents;
